import React, { Component } from "react";
import PropTypes from "prop-types";
import { BrowserRouter as Router, Switch, withRouter } from "react-router-dom";
import { connect } from "react-redux";

// Import Routes
import { publicRoutes } from "./routes/";
import AppRoute from "./routes/route";
// layouts
import NonAuthLayout from "./components/NonAuthLayout";

// Import scss
import "./assets/scss/theme.scss";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  /**
   * Returns the layout
   */

  render() {
    return (
      <React.Fragment>
        <Router>
          <Switch>
            {publicRoutes.map((route, idx) => (
              <AppRoute
                path={route.path}
                layout={NonAuthLayout}
                component={route.component}
                key={idx}
                isAuthProtected={false}
              />
            ))}
          </Switch>
        </Router>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    layout: state.Layout,
  };
};

App.propTypes = {
  layout: PropTypes.object,
  onAutoLogin: PropTypes.func,
};

const mapDispatchToProps = dispatch => ({
  onAutoLogin: () => dispatch(autoLogin()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(App));
